module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("權益與培訓專區")]), _vm._v(" "), _c('div', {
    staticClass: "member_content"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('caption'), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('tbody', _vm._l((this.training), function(row, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(row.content)
      }
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.created_at))])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "success"
  }, [_c('td', [_vm._v("主題")]), _vm._v(" "), _c('td', [_vm._v("檔案")]), _vm._v(" "), _c('td', [_vm._v("日期")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c1d1bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/Training.vue
// module id = 279
// module chunks = 1